module.exports = __webpack_public_path__ + "static/media/1.175d73ab.svg";